<template>
  <div>
    <section class="content-header">
      <h1>
        <span>{{$ml.get('shared.cardDesignTemplates')}}</span>
      </h1>
      <ol class="breadcrumb">
        <li>
          <i class="fa fa-dashboard"></i>
          <span>{{$ml.get('shared.dashboard')}}</span>
        </li>
        <li>
          <i class="fa fa-book"></i>
          <span>{{$ml.get('shared.definitions')}}</span>
        </li>
        <li>
          <span>{{$ml.get('shared.cardDesignTemplates')}}</span>
        </li>
      </ol>
    </section>
    <section class="content">
      <div class="row">
        <div class="col-sm-4">
          <div class="input-group" style="margin-bottom:7px;">
            <input
              type="text"
              :placeholder="$ml.get('general.search')"
              v-model="searchText"
              class="form-control"
              autocomplete="false"
            />
            <span class="input-group-btn">
              <button type="button" class="btn btn-primary">
                <i class="fa fa-search"></i>
              </button>
            </span>
          </div>
          <div class="box box-primary">
            <div class="box-header with-border">
              <h3 class="box-title">
                <span>Kart Şablon Listesi</span>
              </h3>
              <div class="box-tools pull-right">
                <button @click="newCardDesign()" class="btn btn-sm btn-warning">
                  <i class="fa fa-plus"></i> Yeni Kart Tasarımı
                </button>
              </div>
            </div>
            <div class="box-body">
              <div
                v-show="cardDesignList.length > 0"
                class="table-responsive no-padding"
                style="max-height:945px;overflow:auto;"
              >
                <table class="table table-hover">
                  <thead>
                    <tr>
                      <th @click="setOrderName()" style="cursor:pointer;">
                        <strong>
                          Şablon Adı
                          <i v-show="orderNameList == 0" class="fa fa-sort-alpha-asc"></i>
                          <i v-show="orderNameList == 1" class="fa fa-sort-alpha-desc"></i>
                        </strong>
                      </th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      :class="cardDesign.id == cardDesign1.id ? 'bg-primary': ''"
                      style="cursor:pointer;"
                      @click="getCardDesign(cardDesign1.id)"
                      v-for="cardDesign1 in filtered"
                      :key="cardDesign1.id"
                    >
                      <td>{{cardDesign1.name}}</td>
                      <td>
                        <button
                          @click="deleteCardDesign(cardDesign1.id)"
                          class="btn btn-sm btn-danger"
                        >
                          <i class="fa fa-trash"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div v-show="cardDesignList.length == 0" class="callout callout-info">
                <i class="fa fa-info-circle"></i>
                {{$ml.get("alerts.recordNotFound")}}
              </div>
            </div>
          </div>
          <div class="overlay" id="load" :hidden="!isLoadingList">
            <i class="fa fa-refresh fa-spin"></i>
          </div>
        </div>
        <div class="col-sm-8">
          <div class="box box-primary">
            <div class="box-header with-border">
              <h3 class="box-title">
                <span>Şablon Detayı</span>
              </h3>
              <div class="box-tools pull-right">
                <button @click="saveCard()" class="btn btn-sm btn-success">
                  <i class="fa fa-check"></i> Değişiklikleri Kaydet
                </button>
              </div>
            </div>
            <div class="box-body">
              <div class="row">
                <div class="text-center col-sm-6">
                  <div
                    class="customCard"
                    :style="'background-color:'+cardDesign.backgroundColor+';background-image:url('+cardDesign.backgroundImage+');background-size:cover;'"
                  >
                    <img
                      @click="selectItem(item1)"
                      v-for="item1 in cardImageItems"
                      :key="item1.id"
                      :src="item1.imageUrl"
                      :style="imageItemStyle(item1)"
                    />
                    <span
                      @click="selectItem(item2)"
                      v-for="item2 in cardLabelItems"
                      :key="item2.id"
                      :style="itemStyle(item2)"
                    >{{item2.text}}</span>
                    <span
                      @click="selectItem(item3)"
                      v-for="item3 in cardValueItems"
                      :key="item3.id"
                      :style="itemStyle(item3)"
                    >{{getValueTitle(item3.value)}}</span>
                  </div>
                  <hr />
                  <h4>Kullanılan Nesneler</h4>
                  <hr />
                  <div
                    class="input-group"
                    style="margin-bottom:5px;cursor:pointer;"
                    v-for="(cardItem, index) in cardItems"
                    :key="cardItem.id"
                    @click="selectItem(cardItem)"
                  >
                    <span
                      class="input-group-addon"
                      :style="selectedItem.id == cardItem.id ? 'background-color:#00a0f0;color:#ffffff;':''"
                    >
                      <i v-if="cardItem.type == 0" class="fa fa-font"></i>
                      <i v-if="cardItem.type == 1" class="fa fa-lightbulb-o"></i>
                      <i v-if="cardItem.type == 2" class="fa fa-picture-o"></i>
                    </span>
                    <label
                      class="form-control"
                      :style="selectedItem.id == cardItem.id ? 'background-color:#00a0f0;color:#ffffff;cursor:pointer;':'cursor:pointer;'"
                    >{{cardItem.title}}</label>
                    <div class="input-group-btn">
                      <button class="btn btn-danger" @click="removeItem(index)">
                        <i class="fa fa-trash"></i>
                      </button>
                    </div>
                  </div>
                  <button
                    @click="newItem()"
                    class="btn btn-warning"
                    style="width:100%;margin-top:5px;"
                    type="button"
                  >
                    <i class="fa fa-plus"></i> Yeni Nesne
                  </button>
                </div>
                <div class="col-sm-6">
                  <div class="row">
                    <div class="col-sm-12">
                      <div class="form-group">
                        <label>Şablon Adı</label>
                        <input v-model="cardDesign.name" type="text" class="form-control" />
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label>Arkaplan Rengi</label>
                        <input
                          type="color"
                          class="form-control"
                          @change="changebackgroundColor($event)"
                          :value="cardDesign.backgroundColor"
                        />
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label>Arkaplan Görseli</label>
                        <input
                          accept="image/*"
                          @change="onFilePicked($event)"
                          type="file"
                          ref="file"
                          style="display: none"
                        />
                        <button
                          type="button"
                          @click="$refs.file.click()"
                          class="btn btn-primary btn-sm"
                          style="width:100%"
                        >
                          <i class="fa fa-upload"></i>
                          {{$ml.get('employees.selectPhoto')}}
                        </button>
                      </div>
                    </div>
                  </div>
                  <hr />
                  <h4 class="text-center">Tasarım Ayarları</h4>
                  <hr />
                  <div class="form-group">
                    <label>Nesne Tipi</label>
                    <select @change="changeType($event)" type="text" class="form-control">
                      <option :selected="selectedItem.type == 0" value="0">Yazı</option>
                      <option :selected="selectedItem.type == 1" value="1">Değer (Bilgi Alanı)</option>
                      <option :selected="selectedItem.type == 2" value="2">Profil Fotoğrafı</option>
                    </select>
                  </div>
                  <div v-if="selectedItem.type == 1" class="form-group">
                    <label>Değer (Bilgi Alanı)</label>
                    <select @change="changeCardValue($event)" class="form-control">
                      <option
                        v-for="cardValue in cardValues"
                        :key="cardValue.id"
                        :selected="cardValue.id == selectedItem.value"
                        :value="cardValue.id"
                      >{{cardValue.name}}</option>
                    </select>
                  </div>
                  <div v-if="selectedItem.type == 0" class="form-group">
                    <label>Yazı Metni</label>
                    <input v-model="selectedItem.text" type="text" class="form-control" />
                  </div>
                  <div class="row">
                    <div class="col-sm-7">
                      <div class="form-group" v-if="selectedItem.type != 2">
                        <label>
                          Yazı Büyüklüğü :
                          <input
                            v-model="selectedItem.fontSize"
                            type="number"
                            max="323"
                            min="5"
                            class="no-border text-center"
                          /> px
                        </label>
                        <input
                          v-model="selectedItem.fontSize"
                          type="range"
                          max="90"
                          min="3"
                          class="form-control"
                        />
                      </div>
                    </div>
                    <div class="col-sm-5">
                      <div class="form-group" v-if="selectedItem.type != 2">
                        <label>Hizalama</label>
                        <div class="input-group">
                          <div class="btn-group">
                            <button
                              @click="changeAlign('left')"
                              :class="selectedItem.fontAlign == 'left' ? 'btn btn-primary' : 'btn btn-default'"
                            >
                              <i class="fa fa-align-left"></i>
                            </button>
                            <button
                              @click="changeAlign('center')"
                              :class="selectedItem.fontAlign == 'center' ? 'btn btn-primary' : 'btn btn-default'"
                            >
                              <i class="fa fa-align-center"></i>
                            </button>
                            <button
                              @click="changeAlign('right')"
                              :class="selectedItem.fontAlign == 'right' ? 'btn btn-primary' : 'btn btn-default'"
                            >
                              <i class="fa fa-align-right"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-7">
                      <div class="form-group" v-if="selectedItem.type != 2">
                        <label>Yazı Rengi</label>
                        <input
                          type="color"
                          class="form-control"
                          @change="changeFontColor($event)"
                          :value="selectedItem.fontColor"
                        />
                      </div>
                    </div>
                    <div class="col-sm-5">
                      <div class="form-group" v-if="selectedItem.type != 2">
                        <label>Yazı Tipi</label>
                        <div class="input-group">
                          <div class="btn-group">
                            <button
                              @click="changeFontWeight('font-weight:normal;')"
                              :class="selectedItem.fontWeight == 'font-weight:normal;' ? 'btn btn-primary' : 'btn btn-default'"
                            >
                              <i class="fa fa-font"></i>
                            </button>
                            <button
                              @click="changeFontWeight('font-weight:bolder;')"
                              :class="selectedItem.fontWeight == 'font-weight:bolder;' ? 'btn btn-primary' : 'btn btn-default'"
                            >
                              <i class="fa fa-bold"></i>
                            </button>
                            <button
                              @click="changeFontItalic('font-style:italic;')"
                              :class="selectedItem.fontItalic == 'font-style:italic;' ? 'btn btn-primary' : 'btn btn-default'"
                            >
                              <i class="fa fa-italic"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label>
                          Yükseklik :
                          <input
                            v-model="selectedItem.height"
                            type="number"
                            max="323"
                            min="5"
                            class="no-border text-center"
                          /> px
                        </label>
                        <input
                          v-model="selectedItem.height"
                          type="range"
                          max="204"
                          min="5"
                          class="form-control"
                        />
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label>
                          Genişlik :
                          <input
                            v-model="selectedItem.width"
                            type="number"
                            max="323"
                            min="5"
                            class="no-border text-center"
                          /> px
                        </label>
                        <input
                          v-model="selectedItem.width"
                          type="range"
                          max="323"
                          min="5"
                          class="form-control"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label>
                          Üst Boşluk :
                          <input
                            v-model="selectedItem.top"
                            type="number"
                            max="323"
                            min="5"
                            class="no-border text-center"
                          /> px
                        </label>
                        <input
                          v-model="selectedItem.top"
                          type="range"
                          max="190"
                          min="3"
                          class="form-control"
                        />
                      </div>
                    </div>
                    <div class="col-sm-6">
                      <div class="form-group">
                        <label>
                          Sol Boşluk :
                          <input
                            v-model="selectedItem.left"
                            type="number"
                            max="323"
                            min="5"
                            class="no-border text-center"
                          /> px
                        </label>
                        <input
                          v-model="selectedItem.left"
                          type="range"
                          max="300"
                          min="3"
                          class="form-control"
                        />
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-12">
                    <button
                      v-show="!selectedItem.id"
                      @click="addItem()"
                      class="btn btn-success"
                      style="width:100%;"
                    >Nesneyi Ekle</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      isLoadingList: false,
      searchText: "",
      orderNameList: 0,
      cardDesigns: [],
      cardDesign: {
        id: null,
        name: "",
        backgroundImage: null,
        backgroundColor: "#ffffff",
        template: {
          items: []
        }
      },
      selectedItem: {
        id: null,
        title: "",
        type: 0, // 0=Text, 1=Value, 2=Image
        imageUrl: "/src/assets/default-user.png",
        width: 100,
        height: 20,
        top: 10,
        left: 10,
        text: "",
        value: 0,
        fontSize: 12,
        fontAlign: "left",
        fontWeight: "",
        fontItalic: "",
        fontColor: "#000000"
      },
      cardValues: [
        {
          id: 0,
          name: this.$ml.get("employees.registrationNumberInfo")
        },
        {
          id: 1,
          name: this.$ml.get("employees.citizenshipNumber")
        },
        {
          id: 2,
          name: this.$ml.get("employees.nameSurname")
        },
        {
          id: 3,
          name: this.$ml.get("employees.department")
        },
        {
          id: 4,
          name: this.$ml.get("employees.title")
        },
        {
          id: 5,
          name: this.$ml.get("employees.dateofBirth")
        },
        {
          id: 6,
          name: this.$ml.get("employees.dateOfStartWorkInfo")
        },
        {
          id: 7,
          name: this.$ml.get("employees.status")
        },
        {
          id: 8,
          name: this.$ml.get("employees.state")
        },
        {
          id: 9,
          name: this.$ml.get("employees.stateNote")
        },
        {
          id: 10,
          name: this.$ml.get("employees.deviceEmployeeNumber")
        },
        {
          id: 11,
          name: this.$ml.get("employees.deviceStatus")
        },
        {
          id: 12,
          name: this.$ml.get("employees.deviceCardNo")
        },
        {
          id: 13,
          name: this.$ml.get("employees.plateNo")
        },
        {
          id: 14,
          name: this.$ml.get("employees.hgsNo")
        },
        {
          id: 15,
          name: this.$ml.get("employees.workPlan")
        },
        {
          id: 16,
          name: this.$ml.get("employees.documentNo")
        },
        {
          id: 17,
          name: this.$ml.get("employees.email")
        },
        {
          id: 18,
          name: this.$ml.get("employees.address")
        },
        {
          id: 19,
          name: this.$ml.get("employees.mobileNumber")
        },
        {
          id: 20,
          name: this.$ml.get("employees.internal")
        },
        {
          id: 21,
          name: this.$ml.get("employees.homePhone")
        },
        {
          id: 22,
          name: this.$ml.get("employees.gender")
        },
        {
          id: 23,
          name: this.$ml.get("employees.educationStatus")
        },
        {
          id: 24,
          name: this.$ml.get("employees.militaryStatus")
        },
        {
          id: 25,
          name: this.$ml.get("employees.maritalStatus")
        },
        {
          id: 26,
          name: this.$ml.get("employees.drivingLicence")
        },
        {
          id: 27,
          name: this.$ml.get("employees.foreignLanguage")
        },
        {
          id: 28,
          name: this.$ml.get("employees.bloodType")
        }
      ],
      imageData: null
    };
  },
  computed: {
    filtered() {
      return this.cardDesigns;
    },
    cardDesignList() {
      return this.cardDesigns;
    },
    cardItems() {
      return this.cardDesign.template.items;
    },
    cardLabelItems() {
      return this.cardDesign.template.items.filter(a => {
        return a.type == 0;
      });
    },
    cardValueItems() {
      return this.cardDesign.template.items.filter(a => {
        return a.type == 1;
      });
    },
    cardImageItems() {
      return this.cardDesign.template.items.filter(a => {
        return a.type == 2;
      });
    }
  },
  filters: {
    readMore(str) {
      if (str) {
        if (str.length > 75) {
          return str.slice(0, 75) + " ...";
        } else {
          return str;
        }
      } else {
        return str;
      }
    }
  },
  methods: {
    onFilePicked(event) {
      this.isLoading = true;
      const files = event.target.files;
      let filename = files[0].name;
      this.imageData = files[0];
      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        this.cardDesign.backgroundImage = fileReader.result;
      });
      fileReader.readAsDataURL(files[0]);
      this.isLoading = false;
    },
    changebackgroundColor(event) {
      this.cardDesign.backgroundColor = event.target.value;
    },
    changeFontColor(event) {
      this.selectedItem.fontColor = event.target.value;
    },
    changeType(event) {
      this.selectedItem.type = event.target.value;
      if (this.selectedItem.type == 0) {
        this.selectedItem.height = 20;
      } else if (this.selectedItem.type == 1) {
        this.selectedItem.value = this.cardValues[0].id;
        this.selectedItem.height = 20;
      } else {
        this.selectedItem.height = 100;
      }
    },
    changeAlign(align) {
      this.selectedItem.fontAlign = align;
    },
    changeFontWeight(weight) {
      if (this.selectedItem.fontWeight == weight) {
        this.selectedItem.fontWeight = "";
      } else {
        this.selectedItem.fontWeight = weight;
      }
    },
    changeFontItalic(italic) {
      if (this.selectedItem.fontItalic == italic) {
        this.selectedItem.fontItalic = "";
      } else {
        this.selectedItem.fontItalic = italic;
      }
    },
    changeCardValue(event) {
      this.selectedItem.value = event.target.value;
    },
    getValueTitle(valueId) {
      var val = this.cardValues.filter(v => {
        return v.id == valueId;
      });
      if (val[0]) {
        return "{" + val[0].name + "}";
      } else {
        return "";
      }
    },
    removeItem(index) {
      this.cardDesign.template.items.splice(index, 1);
    },
    newCardDesign() {
      this.cardDesign.id = null;
      this.cardDesign.name = "";
      this.cardDesign.backgroundImage = null;
      this.cardDesign.backgroundColor = "#ffffff";
      this.cardDesign.template = {
        items: []
      };
    },
    newItem() {
      var a = {
        id: null,
        title: "",
        type: 0,
        imageUrl: "/src/assets/default-user.png",
        width: 100,
        height: 100,
        top: 10,
        left: 10,
        text: "",
        fontSize: 12,
        fontAlign: "left",
        fontWeight: "",
        fontItalic: "",
        fontColor: "#000000"
      };
      this.selectedItem = a;
    },
    selectItem(cardItem) {
      this.selectedItem = cardItem;
    },
    async addItem() {
      if (this.selectedItem.type == 0) {
        if (this.selectedItem.text == "") {
          alertify.warning("Lütfen bir metin girin...");
          return;
        }
        this.selectedItem.title = this.selectedItem.text;
      } else if (this.selectedItem.type == 1) {
        this.selectedItem.title = await this.getValueTitle(
          this.selectedItem.value
        );
      } else {
        this.selectedItem.title = "Profil Fotoğrafı";
      }
      var index = 1;
      await this.cardDesign.template.items.forEach(a => {
        if (a.id >= index) {
          index = index + 1;
        }
      });
      this.selectedItem.id = index;
      this.cardDesign.template.items.push(this.selectedItem);
    },
    async deleteCardDesign(id) {
      if (!id) {
        alertify.warning(this.$ml.get("alerts.pleaseSelect"));
      } else {
        this.isLoadingReader = true;
        try {
          const response = await this.$axios
            .delete("/CardDesign/" + id)
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                }
              } else {
                if (
                  error.message == "Network Error" ||
                  error.message == "Error: Network Error"
                ) {
                  alertify.error(this.$ml.get("errors.connectionError"));
                  this.isLoadingReader = false;
                  return;
                } else {
                  console.error(error);
                  alertify.error(error.message);
                  this.isLoadingReader = false;
                  return;
                }
              }
            });
          this.getCardDesigns();
          this.newCardDesign();
          alertify.success(this.$ml.get("alerts.deletedSuccessfully"));
          this.isLoadingReader = false;
        } catch (error) {
          alertify.error("Hata Oluştu : " + error);
          this.isLoadingReader = false;
        }
      }
    },
    async saveCard() {
      if (this.cardDesign.name == "") {
        alertify.warning("Lütfen Şablon Adı Girin...");
        return;
      }
      this.isLoading = true;
      if (!this.cardDesign.id) {
        try {
          let image = this.imageData;
          const response = await this.$axios
            .post("/CardDesign", {
              name: this.cardDesign.name,
              template: this.cardDesign.template,
              backgroundColor: this.cardDesign.backgroundColor
            })
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                }
              } else {
                if (
                  error.message == "Network Error" ||
                  error.message == "Error: Network Error"
                ) {
                  alertify.error(this.$ml.get("errors.connectionError"));
                  this.isLoading = false;
                  return;
                } else {
                  console.error(error);
                  alertify.error(error.message);
                  this.isLoading = false;
                  return;
                }
              }
            });
          let id = response.data.id;
          if (this.imageData) {
            const formData = new FormData();
            formData.append("file", image);
            if (this.imageData != null) {
              const responseImage = await this.$axios.post(
                "/CardDesign/AddImage/" + id,
                formData,
                {
                  headers: {
                    "Content-Type": "multipart/form-data"
                  }
                }
              );
            }
          }
          try {
            if (response.status == 200) {
              this.getCardDesigns();
              this.getCardDesign(id);
              alertify.success(this.$ml.get("alerts.savedSuccessfully"));
            } else {
              alertify.error(response.message);
            }
          } catch (error) {}
          this.isLoading = false;
        } catch (error) {
          console.error(error);
          alertify.error(error);
          this.isLoading = false;
        }
      } else {
        //GÜNCELLE
        try {
          let image = this.imageData;
          const response = await this.$axios
            .post("/CardDesign/" + this.cardDesign.id, {
              name: this.cardDesign.name,
              template: this.cardDesign.template,
              backgroundColor: this.cardDesign.backgroundColor
            })
            .catch(error => {
              if (error.response) {
                if (error.response.status == 401) {
                  this.$store.dispatch("logout");
                }
              } else {
                if (
                  error.message == "Network Error" ||
                  error.message == "Error: Network Error"
                ) {
                  alertify.error(this.$ml.get("errors.connectionError"));
                  this.isLoading = false;
                  return;
                } else {
                  console.error(error);
                  alertify.error(error.message);
                  this.isLoading = false;
                  return;
                }
              }
            });
          if (this.imageData) {
            const formData = new FormData();
            formData.append("file", image);
            if (this.imageData != null) {
              const responseImage = await this.$axios.post(
                "/CardDesign/AddImage/" + this.cardDesign.id,
                formData,
                {
                  headers: {
                    "Content-Type": "multipart/form-data"
                  }
                }
              );
            }
          }
          try {
            if (response.status == 200) {
              this.getCardDesigns();
              alertify.success(this.$ml.get("alerts.updatedSuccessfully"));
            } else {
              alertify.error(response.message);
            }
          } catch (error) {}
          this.isLoading = false;
        } catch (error) {
          console.error(error);
          alertify.error(error);
          this.isLoading = false;
        }
      }
    },
    itemStyle(item) {
      var selectedStyle = "";
      if (item.id == this.selectedItem.id) {
        if (item.type == 1) {
          selectedStyle = "border:1px dashed blue;font-weight:initial;";
        } else {
          selectedStyle = "border:1px dashed red;font-weight:initial;";
        }
      }
      return (
        selectedStyle +
        "cursor:pointer;position:absolute;width:" +
        item.width +
        "px;height:" +
        item.height +
        "px;top:" +
        item.top +
        "px;left:" +
        item.left +
        "px;font-size:" +
        item.fontSize +
        "px;text-align:" +
        item.fontAlign +
        ";" +
        item.fontWeight +
        item.fontItalic +
        ";color:" +
        item.fontColor +
        ";"
      );
    },
    imageItemStyle(item) {
      var selectedStyle = "";
      if (item.id == this.selectedItem.id) {
        selectedStyle = "border:1px dashed red;";
      }
      return (
        selectedStyle +
        "cursor:pointer;position:absolute;width:" +
        item.width +
        "px;height:" +
        item.height +
        "px;top:" +
        item.top +
        "px;left:" +
        item.left +
        "px;"
      );
    },
    async getCardDesign(id) {
      try {
        this.isLoadingReader = true;
        const response = await this.$axios
          .get("/CardDesign/" + id)
          .then(response => {
            this.cardDesign = response.data;
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoadingReader = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoadingReader = false;
                return;
              }
            }
          });
      } catch (error) {
        console.error(error);
        alertify.error(error);
        this.isLoadingReader = false;
      }
    },
    async getCardDesigns() {
      try {
        const cardDesigns = [];
        const response = await this.$axios
          .get("/CardDesign")
          .then(response => {
            response.data.forEach(doc => {
              cardDesigns.push({
                id: doc.id,
                name: doc.name,
                backgroundImage: doc.backgroundImage,
                backgroundColor: doc.backgroundColor,
                template: doc.template
              });
            });
          })
          .catch(error => {
            if (error.response) {
              if (error.response.status == 401) {
                this.$store.dispatch("logout");
              }
            } else {
              if (
                error.message == "Network Error" ||
                error.message == "Error: Network Error"
              ) {
                alertify.error(this.$ml.get("errors.connectionError"));
                this.isLoading = false;
                return;
              } else {
                console.error(error);
                alertify.error(error.message);
                this.isLoading = false;
                return;
              }
            }
          });
        this.cardDesigns = cardDesigns;
      } catch (error) {
        console.error(error);
        alertify.error("Servis Hatası :" + error.message);
      }
    }
  },
  async created() {
    await this.getCardDesigns();
  }
};
</script>

<style scoped>
.customCard {
  width: 347px;
  height: 221px;
  border-radius: 10px;
  display: inline-block;
  position: relative;
  border: dotted 1px #cccccc;
}
</style>



// WEBPACK FOOTER //
// src/pages/cardDesign/CardDesign.vue